import type { Task } from './types';

export const firstOpen = (tasks: readonly Task[]): string | null => tasks.find((t) => !t.done)?.id ?? null;

export const openTasks = (tasks: readonly Task[]) => tasks.filter((t) => !t.done);

export const pomodorosLeft = (tasks: readonly Task[]): number =>
  openTasks(tasks).reduce((a, t) => a + Math.max(0, t.est - t.count), 0);

/**
 * Credits one pomodoro to the active task. Completes it when the estimate is reached and
 * selects the next open task. Mutates the task in place.
 */
export function creditActive(
  tasks: Task[],
  activeId: string | null,
): { activeId: string | null; finished: Task | null } {
  const t = tasks.find((x) => x.id === activeId);
  if (!t || t.done) return { activeId, finished: null };
  t.count++;
  if (t.count < t.est) return { activeId, finished: null };
  t.done = true;
  return { activeId: firstOpen(tasks), finished: t };
}

export function move<T>(list: T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item!);
  return next;
}
